import { render, staticRenderFns } from "./DynamicDataField.vue?vue&type=template&id=3c012455&"
import script from "./DynamicDataField.vue?vue&type=script&lang=ts&"
export * from "./DynamicDataField.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicDataField.vue?vue&type=style&index=0&id=3c012455&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports